import React from 'react'

// Stardust types `validationText` as a string but renders it as children, so a span can carry the hook.
export const validationLabel = (qa: string, text: string) =>
  ((<span data-qa={qa}>{text}</span>) as unknown) as string
